<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="panel panel-default form-filtrar form-default" [ngClass]="usuario.retorno.aparencia">
    <h1>Seleção de SubFrota</h1>
    <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
        <div class="input-group">
            <label class="center-block">
                Pesquisar por
            </label>
            <div class="input-group"></div>
            <mat-select [(ngModel)]="filtro.coluna" name="coluna" class="form-control dropdown-filtro"
                matTooltip="Pesquise a SubFrota por" style="min-width: 100px; max-width: 200px;">
                <mat-option value="1">Por Código</mat-option>
                <mat-option value="2">Por Código de Identificação</mat-option>
                <mat-option value="3">Por Descrição</mat-option>
            </mat-select>
            <mat-select [(ngModel)]="filtro.operador" name="operador" class="form-control dropdown-filtro"
                style="min-width: 100px; max-width: 200px; margin-left: 10px;">
                <mat-option [value]=1>Igual a</mat-option>
                <mat-option [value]=2>Maior que</mat-option>
                <mat-option [value]=3>Menor que</mat-option>
                <mat-option [value]=4>Contendo</mat-option>
                <mat-option [value]=5>Iniciando por</mat-option>
            </mat-select>
            <input type="text" #search required [(ngModel)]="filtro.parametro" name="parametro" id="parametro"
                class="form-control" style="margin-left: 10px; min-width: 200px;"
                matTooltip="Preencha para a pesquisa da SubFrota" #parametro="ngModel" />

            <span>Campo é obrigatório</span>
        </div>
        <button type="submit" mat-icon-button style="margin-left: 10px" matTooltip="Pesquise a SubFrota"
            [disabled]="!filtroForm.form.valid">
            <mat-icon aria-hidden="false" aria-label="Pesquise a SubFrota" fontIcon="search"></mat-icon>
        </button>
        <button type="button" mat-icon-button style="margin-left: 10px"
            matTooltip="Limpe o resultado da pesquisa de SubFrota" (click)="limpaFiltro()">
            <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de SubFrota" fontIcon="delete">
            </mat-icon>
        </button>
        <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Fechar" (click)="fechar()">
            <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
            </mat-icon>
        </button>
    </form>
    <div>
        <mat-form-field class="pesquisa-filtro">
            <input matInput #txtVal (keyup)="applyFilter(txtVal.value)" placeholder="Digite para pesquisar SubFrota ...">
        </mat-form-field>
    </div>
    <div class="lista-container">
        <mat-table [dataSource]="dataSource" matSort>

            <!-- Código SubFrota Column -->
            <ng-container matColumnDef="codigo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Código </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.codigo}} </mat-cell>
            </ng-container>

            <!-- Código Identificação Column -->
            <ng-container matColumnDef="codigoIdentificacao">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Código de Identificação </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.codigoIdentificacao}} </mat-cell>
            </ng-container>

            <!-- Descrição Column -->
            <ng-container matColumnDef="descricao">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.descricao}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getRecord(row)">
            </mat-row>

        </mat-table>

        <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[5, 10, 20, 50, 100, 500, 1000, 9999]"
            [pageSize]="5" aria-label="Seleciona a página">
        </mat-paginator>
    </div>
</div> 